export default "__VITE_ASSET__CeuQyf7H__"